'use strict';

var __chunk_1 = require('./chunk-ba04ad2f.js');
var __chunk_4 = require('./chunk-e6d921c6.js');

/**
 * Returns true if the list of `as` is an array of strings, false otherwise.
 *
 * @private
 */

function isArrayOfStrings(as) {
  return __chunk_4.isArray(as) && as.length > 0 && as.reduce(function (a, b) {
    return a && __chunk_1.isString(b);
  }, true);
}

/**
 * Returns an empty monoid of `as`.
 *
 * @private
 */

function mempty(as) {
  return __chunk_1.isString(as) || isArrayOfStrings(as) ? '' : [];
}

exports.isArrayOfStrings = isArrayOfStrings;
exports.mempty = mempty;
